import { render, staticRenderFns } from "./LotAuctionPremium.vue?vue&type=template&id=5be4ada9&scoped=true&"
import script from "./LotAuctionPremium.vue?vue&type=script&lang=js&"
export * from "./LotAuctionPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4ada9",
  null
  
)

export default component.exports